if (!customElements.get('tabs-wrapper')) {
  class TabsWrapper extends HTMLElement {
    static CURRENT_CLASS = 'is-current';

    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      const anchor = event.target.closest('[js-tab-link]');
      if(!anchor) return;

      const target = this.querySelector(anchor.getAttribute('href'));
      if(!target) return;

      event.preventDefault();

      this.querySelectorAll(`.${TabsWrapper.CURRENT_CLASS}`).forEach(element => element.classList.remove(TabsWrapper.CURRENT_CLASS));

      anchor.classList.add(TabsWrapper.CURRENT_CLASS);
      target.classList.add(TabsWrapper.CURRENT_CLASS);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('tabs-wrapper', TabsWrapper);
}
